import { Box, Container, Flex, Grid, GridItem, Heading, Link, Stack, Text } from "@chakra-ui/react";
import Head from "next/head";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const PoliticaNoDiscriminacion = () => {
    return (
        <Container maxWidth={{ base: "7xl", md: "8xl" }} pt={{ base: 14, md: 24 }}>
            <Header />
            <Head>
                <title>Política de No Discriminación</title>
            </Head>
            <Grid templateColumns="repeat(4, 1fr)" gap={6}>
                <GridItem colSpan={1} display={{ base: "none", md: "block" }} fontSize="16px">
                    <Stack mt="28" mb={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones"
                        >
                            Terminos y condiciones Contratación del portal
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiabroker"
                        >
                            Terminos y condiciones Guía broker
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiarent"
                        >
                            Terminos y condiciones Guía Rent
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3} borderLeftColor="#17669D" borderLeftWidth="3px">
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/politicanodiscriminacion"
                        >
                            Política de no discriminación
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/cartaderechosconsumidor"
                        >
                            Carta de derechos del consumidor
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-guiaconnect"
                        >
                            Términos y condiciones Guia Connect
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-soyinmobiliaria"
                        >
                            Terminos y condiciones Soy Inmobiliaria
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-pagocomprasonline"
                        >
                            Términos y Condiciones para la Selección de Forma de Pago en Compras en
                            Línea
                        </Link>
                    </Stack>
                    <Stack my={4} pl={3}>
                        <Link
                            color="#005895"
                            fontWeight="700"
                            fontSize="sm"
                            href="/terminosycondiciones-alianzas"
                        >
                            Términos y Condiciones - Guía Alianzas
                        </Link>
                    </Stack>
                </GridItem>
                <GridItem colSpan={{ base: 4, md: 3 }}>
                    <Box mb="4" mt="24">
                        <Heading
                            as="h1"
                            fontSize={{ md: "4xl", base: "2xl" }}
                            align="left"
                            mb="8"
                            color="accent.500"
                            fontWeight="bold"
                        >
                            Política de No Discriminación
                        </Heading>
                    </Box>
                    <Box lineHeight={2} mb="8">
                        <Text>
                            <strong>PRIMERA:</strong> En GUIA reconocemos los derechos humanos y en
                            general general derechos del consumidor a la no discriminación. Todos
                            los solicitantes de nuestros servicios son igualmente importantes y por
                            lo tanto no hacemos diferencia o selección de ningún tipo, así como
                            tampoco haremos ningún tipo de condicionamiento del consumo ni se
                            reservará derecho de admisión.
                            <br />
                            <br />
                            Lo anterior salvo por causas que afecten la seguridad o tranquilidad del
                            establecimiento, de sus clientes o de las personas discapacitadas, o se
                            funden en disposiciones expresas de otros ordenamientos legales.
                            <br />
                            <br />
                            <strong>SEGUNDA:</strong> Se entiende por discriminación toda
                            distinción, exclusión, restricción o preferencia que, por acción u
                            omisión, con intención o sin ella, no sea objetiva, racional ni
                            proporcional y tenga por objeto o resultado obstaculizar, impedir,
                            menoscabar o anular el reconocimiento, goce o ejercicio de los derechos
                            humanos y libertades, cuando se base en uno o más de los siguientes
                            motivos: 
                        </Text>
                        <Flex my={4}>
                            <Text mr={8}></Text>
                            <Text>
                                2.1 El origen étnico o nacional, el color de piel, la cultura, el
                                sexo, el género, la edad, las discapacidades, la condición social,
                                económica, de salud o jurídica, la religión, la apariencia física,
                                las características genéticas, la situación migratoria, el embarazo,
                                la lengua, las opiniones, las preferencias sexuales, la identidad o
                                filiación política, el estado civil, la situación familiar, las
                                responsabilidades familiares, el idioma, los antecedentes penales o
                                cualquier otro motivo. 
                            </Text>
                        </Flex>
                        <Text>
                            También se entenderá como discriminación la homofobia, la misoginia,
                            cualquier manifestación de xenofobia, la segregación racial, el
                            antisemitismo, así como la discriminación racial y otras formas conexas
                            de intolerancia.
                            <br />
                            <br />
                            Discriminar quiere decir dar un trato distinto a las personas que en
                            esencia son iguales y gozan de los mismos derechos; ese trato distinto
                            genera una desventaja o restringe un derecho a quien lo recibe.
                            <br />
                            <br />
                            <strong>TERCERA:</strong> Cuando GUIA es contratado para la prestación
                            de sus servicios no realiza descuentos ni ofrece beneficios especiales
                            en sentido discriminatorio. Respecto a los inmuebles que comercializa
                            por la contratación de un tercero que así lo encomendó, GUIA no cuenta
                            con facultades para determinar en forma unilateral los precios que se
                            ofertan para cada una de las unidades privativas.
                            <br />
                            <br />
                            En todo lo relacionado con descuentos y promociones sobre los inmuebles
                            comercializados por GUIA son ofrecidas bajo instrucción directa de quien
                            contrata nuestros servicios y se presentan al consumidor en general, sin
                            distinción o condición alguna que genere discriminación.
                            <br />
                            <br />
                            <strong>CUARTA:</strong> El consumidor que acude a cualquiera de los
                            puntos de venta donde se encuentre GUIA prestando servicios, será
                            atendido sin discriminación.
                            <br />
                            <br />
                            <strong>QUINTA:</strong> GUIA comprende la vulneración que existen en
                            determinados determinados sectores de la población y deberá atenderle
                            bajo una visión de equidad. Si usted desea contratar nuestros servicios
                            y cuenta con alguna discapacidad, no es impedimento para atenderle. En
                            este supuesto, usted puede ponerse en contacto con nosotros cuando lo
                            considere adecuado, para determinar junto con usted las condiciones
                            adecuadas para las reuniones que pudieren generarse.
                            <br />
                            <br />
                            <strong>SEXTA:</strong> Para cualquier duda relacionada con la presente
                            política puede usted ponerse en contacto con nosotros.
                            <br />
                            <br />
                            <br />
                            <br />
                        </Text>
                        <Text align="right">
                            Esta política se actualizó el día 08 de Diciembre de 2022. 
                            <br />
                            <br />
                        </Text>
                    </Box>
                </GridItem>
            </Grid>
            <Footer visible={false} />
        </Container>
    );
};

export default PoliticaNoDiscriminacion;
